/** Concatena classi ignorando i valori falsy. Nessuna dipendenza esterna. */
export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter((part): part is string => typeof part === 'string' && part !== '').join(' ');
}
